/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FinancialAndTaxDetailsViewModel } from './FinancialAndTaxDetailsViewModel';
import {
    FinancialAndTaxDetailsViewModelFromJSON,
    FinancialAndTaxDetailsViewModelFromJSONTyped,
    FinancialAndTaxDetailsViewModelToJSON,
} from './FinancialAndTaxDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfFinancialAndTaxDetailsViewModel
 */
export interface ResultOfFinancialAndTaxDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {FinancialAndTaxDetailsViewModel}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    data?: FinancialAndTaxDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfFinancialAndTaxDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfFinancialAndTaxDetailsViewModel interface.
 */
export function instanceOfResultOfFinancialAndTaxDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfFinancialAndTaxDetailsViewModelFromJSON(json: any): ResultOfFinancialAndTaxDetailsViewModel {
    return ResultOfFinancialAndTaxDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfFinancialAndTaxDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfFinancialAndTaxDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : FinancialAndTaxDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfFinancialAndTaxDetailsViewModelToJSON(value?: ResultOfFinancialAndTaxDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': FinancialAndTaxDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

